import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {LOGOUT_FINISHED} from "@atg-global-shared/user/userActionTypes";
import type {HorseFavorites} from "@atg-horse-shared/horse-state";
import {HorseFavoritesActionTypes} from "@atg-horse-shared/horse-state";

const INITIAL_STATE: HorseFavorites = {
    horses: null,
    showHorseFavoritesSettingsModal: false,
    isLoading: false,
    hasError: false,
};

const horseFavorites = (
    state: HorseFavorites = INITIAL_STATE,
    action: HorseFavoritesActionTypes.Types | {type: typeof LOGOUT_FINISHED},
): HorseFavorites => {
    switch (action.type) {
        case HorseFavoritesActionTypes.STORE_FAVORITE_HORSE:
            return {
                ...state,
                horses: state.horses ? [...state.horses, action.horse] : [action.horse],
            };

        case HorseFavoritesActionTypes.STORE_ALL_FAVORITE_HORSES:
            return {
                ...state,
                horses: action.horses,
            };

        case HorseFavoritesActionTypes.STORE_FAVORITES_PREFERENCES:
            return {
                ...state,
                preferences: action.preferences,
            };

        case HorseFavoritesActionTypes.REMOVE_FAVORITE_HORSE_FROM_STORE:
            return {
                ...state,
                horses: state.horses
                    ? state.horses.filter((horse) => horse.id !== action.horseId)
                    : null,
            };

        case HorseFavoritesActionTypes.CLOSE_HORSE_FAVORITES_SETTINGS_MODAL:
            return {
                ...state,
                showHorseFavoritesSettingsModal: false,
            };

        case HorseFavoritesActionTypes.SHOW_HORSE_FAVORITES_SETTINGS_MODAL:
            return {
                ...state,
                showHorseFavoritesSettingsModal: true,
            };

        case HorseFavoritesActionTypes.LOADING_STARTED:
            return {
                ...state,
                isLoading: true,
            };

        case HorseFavoritesActionTypes.LOADING_FINISHED:
            return {
                ...state,
                isLoading: false,
            };

        case HorseFavoritesActionTypes.SET_ERROR:
            return {
                ...state,
                hasError: true,
            };

        case HorseFavoritesActionTypes.CLEAR_ERROR:
            return {
                ...state,
                hasError: false,
            };

        case LOGOUT_FINISHED:
            return {
                ...state,
                horses: null,
                preferences: undefined,
                showHorseFavoritesSettingsModal: false,
                isLoading: false,
            };

        default:
            return state;
    }
};

const horseFavoritesPersistConfig = {
    storage,
    key: "horseFavorites",
    version: 0,
};

export default persistReducer(horseFavoritesPersistConfig, horseFavorites);
